import { api } from './api';
import type { Patient, PatientSummary, CreatePatientInput } from '@dpfs/shared';

export interface SearchPatientsParams {
  q: string;
  limit?: number;
}

export const patientsService = {
  async create(input: CreatePatientInput): Promise<Patient> {
    const response = await api.post('/patients', input);
    return response.data;
  },

  async search(params: SearchPatientsParams): Promise<{ patients: PatientSummary[] }> {
    const response = await api.get('/patients/search', { params });
    return response.data;
  },

  async getById(id: string): Promise<Patient> {
    const response = await api.get(`/patients/${id}`);
    return response.data;
  },

  async update(id: string, input: Partial<CreatePatientInput>): Promise<Patient> {
    const response = await api.patch(`/patients/${id}`, input);
    return response.data;
  },

  async getPrescriptions(id: string): Promise<{ prescriptions: unknown[] }> {
    const response = await api.get(`/patients/${id}/prescriptions`);
    return response.data;
  },
};
